import postalIcon from '../../../assets/postalIcon.png'
import { DownloadIcon } from '../Icons/download'
import { BriefIcon } from '../Icons/briefcase'

type FileCriteriaKey = 'postal_code_list' | 'hs_code'

interface InputFileDetailProps {
    name: string
    valueKey: FileCriteriaKey
    onDownload: () => void
    isDownloading?: boolean
    criteria_quantity: number
}

export const InputFileDetail = ({
    name,
    valueKey,
    onDownload,
    isDownloading = false,
    criteria_quantity,
}: InputFileDetailProps) => {
    const fileDescriptions: Record<FileCriteriaKey, string> = {
        postal_code_list: `Archivo con lista de ${criteria_quantity} códigos postales`,
        hs_code: `Archivo con lista de ${criteria_quantity} HS Codes`,
    }

    return (
        <div className="flex items-center mb-2">
            {valueKey === 'hs_code' ? (
                <BriefIcon />
            ) : (
                <img src={postalIcon} alt={`${name} icon`} />
            )}
            <h3 className="text-[#141A1F] text-[14px] font-normal ml-2">
                {name}:{' '}
                <span className="ml-2 bg-[#F1F5F9] text-[#3E5060] rounded px-2 py-1 text-sm">
                    {fileDescriptions[valueKey]}
                </span>
            </h3>
            <button
                type="button"
                onClick={onDownload}
                disabled={isDownloading}
                className="ml-2 disabled:cursor-not-allowed"
                aria-label={`Descargar ${name}`}
                aria-busy={isDownloading}
            >
                {isDownloading ? (
                    <span
                        role="status"
                        aria-label="Descargando"
                        className="block h-4 w-4 animate-spin rounded-full border-2 border-[#26303B] border-t-transparent"
                    />
                ) : (
                    <DownloadIcon />
                )}
            </button>
        </div>
    )
}
